import { PromotionBanner } from "@src/appV2/redesign/system/ui-components";

export interface SetUpStripeAccountBannerProps {
  onSetUpStripeAccountClick: () => void;
}

export function SetUpStripeAccountBanner(props: SetUpStripeAccountBannerProps) {
  const { onSetUpStripeAccountClick } = props;

  return (
    <PromotionBanner
      title="Set up payments"
      subtitle="Set up your Stripe account to get paid seamlessly after every shift."
      icon="dollar-info-colored"
      borderVariant="none"
      backgroundColor={(theme) => theme.palette.intent!.info.gradient!}
      ctaButtonText="Set up Stripe account"
      ctaButtonVariant="outlined"
      sx={{
        "& .MuiButtonBase-root": {
          border: "none",
          boxShadow: "none",
        },
        height: "100%",
      }}
      onClick={onSetUpStripeAccountClick}
    />
  );
}
